import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InstantAnalysisRoutingModule } from './instant-analysis-routing.module';
import { MapComponent } from './map/map.component';
import { AlertListComponent } from './alert-list/alert-list.component';
import { AlertMatrixComponent } from './alert-matrix/alert-matrix.component';
import { DatelistComponent } from './datelist/datelist.component';
import { DiscreteLegendComponent } from './discrete-legend/discrete-legend.component';
import { LegendComponent } from './legend/legend.component';
import { HeatmatrixComponent } from './heatmatrix/heatmatrix.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { SharedModule } from '../shared/shared.module';
import { RegionDialogComponent } from './map/region-dialog/region-dialog.component';
import { LegendGroupComponent } from './legend-group/legend-group.component';
import { CoreMapComponent } from './core-map/core-map.component';
import { LandslideLegendGroupComponent } from './landslide-legend-group/landslide-legend-group.component';
import { RouteIterationTableComponent } from './route-iteration-table/route-iteration-table.component';
import { RouteChildrenTableComponent } from './route-iteration-table/route-children-table/route-children-table.component';


/**
 * Módulo do mapa da análise instantânea.
 * 
 * Foca em análises da chuva em um instante de tempo específico.
 * Possui funcionalidade de atualização do mapa em tempo real.
 */
@NgModule({
  declarations: [
    AlertListComponent,
    AlertMatrixComponent,
    DatelistComponent,
    DiscreteLegendComponent,
    HeatmatrixComponent,
    LegendComponent,
    MapComponent,
    ToolbarComponent,
    RegionDialogComponent,
    LegendGroupComponent,
    CoreMapComponent,
    LandslideLegendGroupComponent,
    RouteIterationTableComponent,
    RouteChildrenTableComponent,
  ],
  imports: [
    CommonModule,
    InstantAnalysisRoutingModule,
    SharedModule,
  ],
  exports:[
    DiscreteLegendComponent,
    HeatmatrixComponent,
    LegendComponent,
    LegendGroupComponent,
  ]
})
export class InstantAnalysisModule { }
